import Ajax from '../util/ajax';
import { isDeviceStates, updateDeviceStates } from '../reducers/device_states';
export const TRANSMITTER = 'TRANSMITTER';
export function transmitter(id, command) {
    console.log('Transmitter ' + id + ' ' + command);
    return (dispatch) => {
        const success = (data) => {
            if (data !== null && typeof (data) == 'object' && 'device_states' in data) {
                if (isDeviceStates(data.device_states)) {
                    dispatch(updateDeviceStates(data.device_states));
                }
            }
        };
        const a = new Ajax(dispatch);
        a.post('/transmitter/' + id + '/' + command, undefined, success);
        dispatch({
            type: TRANSMITTER,
            id,
            command
        });
    };
}
